export default {
      id: "i-modal-success-usage",
      viewBox: "0 0 169 169",
      url: __webpack_public_path__ + "img/sprite.svg#i-modal-success",
      toString: function () {
        return this.url;
      }
    }